import PropTypes from "prop-types";
import React, { Component } from "react";
import { IP } from "../../../../config/IP";
import Thumb from "./../../Thumb";

class CartProduct extends Component {
	static propTypes = {
		product: PropTypes.object.isRequired,
		removeProduct: PropTypes.func.isRequired,
	};

	state = {
		isMouseOver: false,
	};

	handleMouseOver = () => {
		this.setState({ isMouseOver: true });
	};

	handleMouseOut = () => {
		this.setState({ isMouseOver: false });
	};

	render() {
		const { product, removeProduct } = this.props;

		const classes = ["shelf-item"];

		if (!!this.state.isMouseOver) {
			classes.push("shelf-item--mouseover");
		}

		return (
			<div className={classes.join(" ")}>
				<div
					className="shelf-item__del"
					onMouseOver={() => this.handleMouseOver()}
					onMouseOut={() => this.handleMouseOut()}
					onClick={() => removeProduct(product)}
				/>
				<Thumb
					classes="shelf-item__thumb"
					// src={require(`../../../static/products/${product.sku}_2.jpg`)}
					//src={require(`../../../static/products/12064273040195392_2.jpg`)}
					src={`${IP.nodeServer}api/getProductPhoto?album=${encodeURIComponent(
						product.sku
					)}`}
					alt={product.title}
				/>
				<div className="shelf-item__details">
					<p className="title">{product.title}</p>
					<p className="desc">
						{`${product.availableSizes[0]} | ${product.style}`} <br />
						Quantity: {product.quantity}
					</p>
				</div>
				<div className="shelf-item__price">
					<p>{`${product.currencyFormat}  ${Intl.NumberFormat().format(
						product.price
					)}`}</p>
				</div>

				<div className="clearfix" />
			</div>
		);
	}
}

export default CartProduct;
